import { render, staticRenderFns } from "./ObservationLanding.vue?vue&type=template&id=0621b58f&scoped=true"
import script from "./ObservationLanding.vue?vue&type=script&lang=js"
export * from "./ObservationLanding.vue?vue&type=script&lang=js"
import style0 from "./ObservationLanding.vue?vue&type=style&index=0&id=0621b58f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0621b58f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VList,VListItem,VSpacer,VTextField})
